// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import './SocialLogin.css';


// function SocialLogin() {
//   const navigate = useNavigate();
//   const { loginCompany } = useAuth();

//   // Initialize Google OAuth client when component mounts
//   useEffect(() => {
//     // Load Google's OAuth 2.0 client library
//     const loadGoogleScript = () => {
//       const script = document.createElement('script');
//       script.src = 'https://accounts.google.com/gsi/client';
//       script.async = true;
//       script.defer = true;
//       document.body.appendChild(script);
      
//       script.onload = () => {
//         if (window.google) {
//           initializeGoogleLogin();
//         }
//       };
//     };
    
//     if (!window.google) {
//       loadGoogleScript();
//     } else {
//       initializeGoogleLogin();
//     }
    
//     return () => {
//       // Clean up any Google auth listeners if needed
//     };
//   }, []);
  
//   // Initialize Google login
//   const initializeGoogleLogin = () => {
//       window.google.accounts.id.initialize({
//         client_id: '859791521611-il745k9lf055oluti7s2les6nsmu5hdn.apps.googleusercontent.com',
//         callback: handleGoogleResponse,
//         auto_select: false,
//         cancel_on_tap_outside: true,
//         context: 'signin', // Add this line
//         ux_mode: 'popup', // Explicitly set the UX mode
     
//     });
//   };
  
//   // Handle Google login response
//   const handleGoogleResponse = async (response) => {
//     if (response.credential) {
//       try {
//         // Send the token to your backend
//         const backendResponse = await fetch('/api/auth/google', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ token: response.credential }),
//         });
        
//         if (!backendResponse.ok) {
//           throw new Error('Failed to authenticate with Google');
//         }
        
//         const data = await backendResponse.json();
        
//         // Login the user using your auth context
//         loginCompany(data.email);
        
//         // Redirect to company home
//         navigate('/user-home');
//       } catch (error) {
//         console.error('Google authentication error:', error);
//         alert('Failed to log in with Google. Please try again.');
//       }
//     }
//   };
  
//   // Handle manual Google login button click
//   const handleGoogleLogin = () => {
//     if (window.google && window.google.accounts && window.google.accounts.id) {
//       window.google.accounts.id.prompt(); // shows popup based on your UX mode ('popup' or 'redirect')
//     } else {
//       alert('Google Sign-In is not available right now. Please try again later.');
//     }
//   };
  
  
//   // Handle LinkedIn login
//   const handleLinkedInLogin = async () => {
//     // LinkedIn OAuth 2.0 authorization endpoint
//     const linkedInAuthUrl = new URL('https://www.linkedin.com/oauth/v2/authorization');
    
//     // Add required parameters
//     linkedInAuthUrl.searchParams.append('response_type', 'code');
//     linkedInAuthUrl.searchParams.append('client_id', 'YOUR_LINKEDIN_CLIENT_ID'); // Replace with your client ID
//     linkedInAuthUrl.searchParams.append('redirect_uri', `${window.location.origin}/auth/linkedin/callback`);
//     linkedInAuthUrl.searchParams.append('state', crypto.randomUUID()); // Generate a random state
//     linkedInAuthUrl.searchParams.append('scope', 'r_liteprofile r_emailaddress');
    
//     // Store state in sessionStorage to verify when user returns
//     sessionStorage.setItem('linkedin_oauth_state', linkedInAuthUrl.searchParams.get('state'));
    
//     // Redirect to LinkedIn authorization page
//     window.location.href = linkedInAuthUrl.toString();
//   };

//   return (
//     <div className="social-login">
//       <p className="social-login-text">
//         <span className="text-bold">Login</span> with Others
//       </p>

//       <button className="social-button google">
//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/6eeaec7c748b8433b38763a968e69e291265f3958f03f5ff89e87bcfae61a444?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
//           alt="Google icon"
//           className="social-icon"
//           onClick={handleGoogleLogin}
//            type="button"
//           id="google-signin-button"
//         />
//         <span>Login with <strong>google</strong></span>
//       </button>

//       <button className="social-button linkedin">
//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/c0b949139a9ddf4f4f5ac6973d797b4430236df90e6f8ec8343a8b4273129caa?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
//           alt="LinkedIn icon"
//           className="social-icon"
//         />
//         <span>Login with <strong>Linkedin</strong></span>
//       </button>
//     </div>
//   );
// }

// export default SocialLogin;


import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

function SocialLogin() {
  const navigate = useNavigate();
  // IMPORTANT: this is the USER login page — call loginUser, NOT loginCompany.
  // Previously this was loginCompany (copy-paste from Company/Login/SocialLogin.jsx),
  // which stored Google-signed-in users in the companyEmail slot of AuthContext.
  // The rest of the user-side app reads userEmail, so users appeared logged out
  // even after a successful Google sign-in.
  const { loginUser } = useAuth();

  // Load Google OAuth client script
  useEffect(() => {
    const loadGoogleScript = () => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        // Script loaded successfully
        if (!window.google || !window.google.accounts) {
          alert('Google Sign-In failed to load.');
        }
      };
    };

    if (!window.google || !window.google.accounts) {
      loadGoogleScript();
    }
  }, []);

  // ✅ Handle Google login manually with popup
  const handleGoogleLogin = () => {
    if (window.google && window.google.accounts) {
      const client = window.google.accounts.oauth2.initTokenClient({
        client_id: '859791521611-il745k9lf055oluti7s2les6nsmu5hdn.apps.googleusercontent.com',
        scope: 'email profile openid',
        callback: async (tokenResponse) => {
          try {
            const backendResponse = await fetch('/api/auth/google', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ token: tokenResponse.access_token }),
            });

            if (!backendResponse.ok) throw new Error('Google login failed');
            const data = await backendResponse.json();
            loginUser(data.email);
            navigate('/user-home');
          } catch (error) {
            console.error('Google login error:', error);
            alert('Failed to login with Google.');
          }
        },
      });

      client.requestAccessToken(); // ✅ Trigger the popup
    } else {
      alert('Google Sign-In is not ready. Please try again later.');
    }
  };

  // LinkedIn OAuth (OpenID Connect flow).
  //
  // Scopes 'openid profile email' are the modern "Sign In with LinkedIn using
  // OIDC" product. The old `r_liteprofile`/`r_emailaddress` scopes were
  // deprecated by LinkedIn in 2023 and no longer work for new apps.
  //
  // We also remember which login flow ("user" vs "company") this redirect
  // came from, so the callback page can route correctly without us
  // needing two different LinkedIn redirect URIs.
  const handleLinkedInLogin = () => {
    const clientId = 'YOUR_LINKEDIN_CLIENT_ID'; // ← Replace with your real LinkedIn Client ID after registering the app at https://www.linkedin.com/developers/apps
    const redirectUri = `${window.location.origin}/auth/linkedin/callback`;
    const state = crypto.randomUUID();

    sessionStorage.setItem('linkedin_oauth_state', state);
    sessionStorage.setItem('linkedin_login_flow', 'user'); // tells callback to use loginUser

    const linkedInAuthUrl = new URL('https://www.linkedin.com/oauth/v2/authorization');
    linkedInAuthUrl.searchParams.append('response_type', 'code');
    linkedInAuthUrl.searchParams.append('client_id', clientId);
    linkedInAuthUrl.searchParams.append('redirect_uri', redirectUri);
    linkedInAuthUrl.searchParams.append('state', state);
    linkedInAuthUrl.searchParams.append('scope', 'openid profile email');

    window.location.href = linkedInAuthUrl.toString();
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <Separator />
        </div>
        <div className="relative flex justify-center text-xs">
          <span className="bg-card px-2 text-muted-foreground">Or continue with</span>
        </div>
      </div>
      
      <div className="flex items-center justify-center gap-3">
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={cn(
            "h-10 w-10 rounded-md",
            "border-border hover:bg-accent hover:border-primary/20",
            "transition-all duration-200 shadow-sm hover:shadow"
          )}
          aria-label="Sign in with Google"
          onClick={handleGoogleLogin}
        >
          <img 
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6eeaec7c748b8433b38763a968e69e291265f3958f03f5ff89e87bcfae61a444?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
            alt="Google"
            className="w-5 h-5"
          />
        </Button>
        
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={cn(
            "h-10 w-10 rounded-md",
            "border-border hover:bg-accent hover:border-primary/20",
            "transition-all duration-200 shadow-sm hover:shadow"
          )}
          aria-label="Sign in with LinkedIn"
          onClick={handleLinkedInLogin}
        >
          <img 
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/c0b949139a9ddf4f4f5ac6973d797b4430236df90e6f8ec8343a8b4273129caa?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
            alt="LinkedIn"
            className="w-5 h-5"
          />
        </Button>
      </div>
    </div>
  );
}

export default SocialLogin;
